import React, { useEffect } from "react";
import { getScrollContainer } from "./utils/scrollContainer";

export default function withScrollOnLeave(Component) {
  const WithScrollOnLeaveWrapper = props => {
    useEffect(
      () => () => {
        getScrollContainer()?.scrollTo(0, 0);
      },
      []
    );

    return <Component {...props} />;
  };

  WithScrollOnLeaveWrapper.propTypes = {};

  return WithScrollOnLeaveWrapper;
}
